export default class RateLimitExceededError extends Error {}